import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "seatbelt"
const SeatbeltIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 12.75C12.902 12.75 13.713 12.861 14.44 13.063L13.173 14.33Q12.628 14.25 12 14.25C10.272 14.25 9.024 14.722 8.108 15.394 7.183 16.072 6.55 16.987 6.12 17.936S5.47 19.844 5.358 20.573Q5.324 20.805 5.303 21H6.503L5.004 22.5H3.75V21.75H4.5 3.75V21.716L3.752 21.634Q3.754 21.531 3.766 21.347C3.782 21.103 3.814 20.76 3.876 20.35 4 19.53 4.249 18.427 4.755 17.314S6.035 15.054 7.22 14.185C8.413 13.31 9.978 12.75 12 12.75" />
          <path
            fillRule="evenodd"
            d="M19.235 11.36C19.82 11.946 19.82 12.895 19.235 13.48L17.71 15.004C18.39 15.717 18.886 16.524 19.245 17.314 19.751 18.428 20 19.531 20.124 20.35 20.186 20.759 20.218 21.104 20.234 21.347Q20.245 21.531 20.248 21.634L20.25 21.716V21.749L19.5 21.75H20.25V22.5H7.125L18.75 10.875zM11.715 21H18.698Q18.675 20.804 18.642 20.573C18.532 19.844 18.312 18.885 17.88 17.936 17.579 17.273 17.178 16.626 16.65 16.066z"
            clipRule="evenodd"
          />
          <path d="M13.875 6.75C13.875 7.148 13.717 7.53 13.435 7.81 13.156 8.093 12.773 8.25 12.375 8.25S11.595 8.092 11.315 7.81C11.033 7.53 10.875 7.149 10.875 6.75z" />
          <path
            fillRule="evenodd"
            d="M12.375 1.5C15.067 1.5 17.25 3.683 17.25 6.375S15.067 11.25 12.375 11.25 7.5 9.067 7.5 6.375 9.683 1.5 12.375 1.5M12.375 3C10.511 3 9 4.511 9 6.375S10.511 9.75 12.375 9.75 15.75 8.239 15.75 6.375 14.239 3 12.375 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SeatbeltIcon
